var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08433 10.9983C8.08433 10.9983 9.19338 8.97063 9.41523 6.94292C9.63708 4.91522 8.97157 3.33813 8.97157 3.33813L11.1902 1.98633C11.1902 1.98633 11.6336 4.68994 11.6336 6.04172M9.41545 13.702C9.41545 13.702 10.7465 12.8008 12.5213 11.8996C14.2961 10.9984 18.2896 10.9984 18.2896 10.9984L16.9584 7.84419C16.9584 7.84419 13.4086 7.84419 12.0777 9.19599M1.87235 19.5597C0.984737 18.8838 0.985505 16.4459 2.76 15.0537C4.53448 13.6616 4.61706 14.0252 6.75315 12.3501C8.88925 10.6751 14.2962 1.98633 14.2962 1.98633L16.2929 3.56343L10.8842 10.8813C9.55995 12.673 9.21644 15.0776 8.10681 17.0139C7.24172 18.5235 6.3094 19.1091 5.42199 19.5597C4.53457 20.0103 2.75995 20.2356 1.87235 19.5597Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.c573fb568b8ec35117b2a8026cd6183c.svg";
export { ForwardRef as ReactComponent };